import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';
import { UnsavedChangesGuard } from '../../shared/guards/unsaved-changes.guard';

export const directOnboardingRoute: Route = {
  path: 'direct-onboarding',
  canActivate: [PermissionGuard],
  data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER] },
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    {
      path: 'list',
      loadComponent: () =>
        import('./list/list.component').then((c) => c.DirectOnboardingListComponent),
    },
    {
      path: 'create',
      loadComponent: () =>
        import('../proposal/create/create.component').then((c) => c.ProposalCreateComponent),
      canDeactivate: [UnsavedChangesGuard],
    },
    {
      path: 'preview/:id',
      loadComponent: () =>
        import('../proposal/create/create.component').then((c) => c.ProposalCreateComponent),
      canDeactivate: [UnsavedChangesGuard],
    },
    {
      path: 'view/:id',
      loadComponent: () =>
        import('../proposal/create/create.component').then((c) => c.ProposalCreateComponent),
      canDeactivate: [UnsavedChangesGuard],
    },
  ],
};
